import { Component, inject, OnInit } from '@angular/core';
import { Verse } from '@models/Verse';
import { CommonModule } from '@angular/common';
import { WordDisplayComponent } from '../word-display/word-display.component';
import { MatCardModule } from '@angular/material/card';
import { PhraseGlossDisplayComponent } from '../phrase-gloss-display/phrase-gloss-display.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PhraseGlossEditorDialogComponent } from '../phrase-gloss-editor-dialog/phrase-gloss-editor-dialog.component';
import { Gloss } from '@models/Gloss';
import { PhraseGlossLocation } from '@models/gloss-locations';
import { SynchronizerService } from '../../synchronizer.service';

@Component({
  selector: 'app-verse-display',
  templateUrl: './verse-display.component.html',
  styleUrl: './verse-display.component.scss',
  imports: [CommonModule, WordDisplayComponent, MatCardModule, PhraseGlossDisplayComponent, MatIconModule, MatButtonModule, MatProgressSpinnerModule]
})
export class VerseDisplayComponent implements OnInit {
  readonly dialog = inject(MatDialog);
  public phraseGlossKeys: PhraseGlossLocation[] = [];

  constructor(private synchronizerService: SynchronizerService) {
  }

  ngOnInit() {
    this.synchronizerService.verse$.subscribe(() => {
      this.refreshPhrasalGlossKeys();
    });
  }

  get verse(): Verse | undefined | null {
    return this.synchronizerService.verse$.value;
  }

  get phraseGlosses(): Map<string, Gloss[]> {
    return Verse.sortPhraseGlosses(this.verse?.phraseGlosses || []);
  }

  addPhrasalGloss(): void {
    const dialogRef = this.dialog.open(PhraseGlossEditorDialogComponent, {
      data: { verse: this.verse, project: this.synchronizerService.currentProject },
    });

    dialogRef.afterClosed().subscribe((g: Gloss) => {
      if (g && this.verse) {
        g.markAsChanged();
        this.verse.addPhraseGloss(g);
        this.refreshPhrasalGlossKeys();
      }
    });
  }

  refreshPhrasalGlossKeys(): void {
    if (this.verse) {
      this.phraseGlossKeys = Array.from(this.phraseGlosses.keys()).map(key => PhraseGlossLocation.fromString(key)).sort(PhraseGlossLocation.compare);
    }
  }

}
